<svg
    [attr.viewBox]="'0 0 ' + width + ' ' + height"
    preserveAspectRatio="none"
    class="sparkline-svg"
    [class.sparkline-svg--with-labels]="showLabels"
    role="img"
    [attr.aria-label]="computedAriaLabel"
>
    <polyline
        *ngFor="let segment of segments; trackBy: trackSegment"
        class="sparkline-line"
        [attr.points]="segment.pointsAttr"
    ></polyline>

    <circle
        *ngFor="let point of nonZeroPoints; trackBy: trackPoint"
        class="sparkline-dot"
        [attr.cx]="point.x"
        [attr.cy]="point.y"
        r="2"
    ></circle>

    <line
        *ngFor="let point of zeroPoints; trackBy: trackPoint"
        class="sparkline-zero-tick"
        [attr.x1]="point.x"
        [attr.x2]="point.x"
        [attr.y1]="point.y - 4"
        [attr.y2]="point.y + 4"
    ></line>

    <ng-container *ngIf="showLabels">
        <text
            *ngFor="let labelPoint of labelPoints"
            class="sparkline-axis-label"
            [attr.x]="labelPoint.x"
            [attr.y]="labelY"
            text-anchor="middle"
        >{{ pointLabels?.[labelPoint.index] }}</text>
    </ng-container>
</svg>
